module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "working-areas"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }), _vm._v(" "), _c('p', [_vm._v("Here you can create, manage and edit your company structure.")]), _vm._v(" "), _c('div', {
    staticClass: "areas-wrapper",
    attrs: {
      "id": "areas-wrapper"
    }
  }, _vm._l((_vm.globalArea), function(value, index) {
    return _c('div', {
      staticClass: "area"
    }, [_c('b-list-group', {
      style: ('padding-top: ' + _vm.getMarginTopArea(index) + 'px')
    }, [_vm._l((value), function(item, key) {
      return [(item.is_active) ? _c('b-list-group-item', {
        class: ['list-grouped', !item.is_active ? 'danger' : ''],
        attrs: {
          "active": item.id == value.activeId
        },
        nativeOn: {
          "click": function($event) {
            value.activeId = item.id;
            _vm.onClick($event, item, index)
          }
        }
      }, [_c('div', {
        staticClass: "list-group__text"
      }, [_c('img', {
        staticClass: "list-group__img",
        attrs: {
          "src": item.picture
        }
      }), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('b-dropdown', {
        staticClass: "m-md-2 dropdown-action",
        attrs: {
          "text": "Action"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.dropdownShowen()
          }
        }
      }, [_c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaName($event, index, key)
          }
        }
      }, [_vm._v("Edit name")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.setWorkHours(item.id, item.custom_shifts)
          }
        }
      }, [_vm._v("Set custom work hours")]), _vm._v(" "), (_vm.isHaveSubarea(item.subareas)) ? _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalDeleteSubArea($event, index, key)
          }
        }
      }, [_vm._v("Remove subordinate")]) : _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalAddArea($event, index, key)
          }
        }
      }, [_vm._v("Add subordinate")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalDeleteArea($event, index, key)
          }
        }
      }, [_vm._v("Delete object")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaPicture($event, index, key)
          }
        }
      }, [_vm._v("Assign icon")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaLabel($event, index, key)
          }
        }
      }, [_vm._v("Add label")])], 1)], 1) : _vm._e()]
    }), _vm._v(" "), (index == 0 || _vm.isHaveSubarea(value)) ? _c('b-list-group-item', {
      staticClass: "add-new-area"
    }, [_c('span', {
      staticClass: "add-new-area",
      on: {
        "click": function($event) {
          return _vm.showModalAddArea($event, index)
        }
      }
    }, [_vm._v("\n            + add one more\n            ")]), _vm._v(" "), _c('b-modal', {
      ref: "modalAddArea",
      refInFor: true,
      attrs: {
        "title": "Add area"
      },
      on: {
        "ok": function($event) {
          return _vm.submitAddNewArea($event, index)
        },
        "shown": _vm.clearName
      }
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.submitAddNewArea($event, index)
        }
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": "Enter new area name"
      },
      model: {
        value: (_vm.newAreaName),
        callback: function($$v) {
          _vm.newAreaName = $$v
        },
        expression: "newAreaName"
      }
    })], 1)])], 1) : _vm._e()], 2)], 1)
  }), 0), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeAreaPicture",
    attrs: {
      "title": "Change area icon"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeAreaPicture($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeAreaPicture($event)
      }
    }
  }, [_c('b-form-file', {
    ref: "pictureFileInput",
    attrs: {
      "placeholder": "New area icon",
      "accept": ".jpg, .jpeg, .png"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.changeImageFile($event)
      }
    },
    model: {
      value: (_vm.areaModal.picture),
      callback: function($$v) {
        _vm.$set(_vm.areaModal, "picture", $$v)
      },
      expression: "areaModal.picture"
    }
  })], 1), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeNameArea",
    attrs: {
      "title": "Change area name"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeArea($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeArea($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaModal.name),
      expression: "areaModal.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "New area name"
    },
    domProps: {
      "value": (_vm.areaModal.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.areaModal, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeLabelArea",
    attrs: {
      "title": "Change area label"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeAreaLabel($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeAreaLabel($event)
      }
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "New area label"
    },
    model: {
      value: (_vm.areaModal.label),
      callback: function($$v) {
        _vm.$set(_vm.areaModal, "label", $$v)
      },
      expression: "areaModal.label"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "modalDeleteArea",
    attrs: {
      "title": "Delete area"
    },
    on: {
      "ok": function($event) {
        return _vm.submitDeleteArea($event)
      }
    }
  }, [_vm._v("\n      Are you sure you want to delete this area, all its data and sub-areas?\n    ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalDeleteSubArea",
    attrs: {
      "title": "Delete subareas"
    },
    on: {
      "ok": function($event) {
        return _vm.submitDeleteSubArea($event)
      }
    }
  }, [_vm._v("\n      You are about to delete the whole subarea and it's contents. "), _c('br'), _vm._v("Are you sure?\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7baa06c7","hasScoped":false}!./src/components/workingAreas/workingAreas.component.html
// module id = 546
// module chunks = 1